"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var regex_1 = require("./utils/regex");

var dashRegex = /[ .]/g;
var percentRegex = /%/g;

function getSafeValue(value) {
  return value.replace(dashRegex, '-').replace(percentRegex, 'prcnt').replace(regex_1.unsafeClassNameCharacters, '');
}

exports["default"] = getSafeValue;